class ScrollingPromotion extends HTMLElement {
  constructor() {
    super();
    this.mq = window.matchMedia("(max-width: 749px)");
    this.config = {
      moveTime: parseFloat(this.dataset.speed) || 1,
      space: 100,
    };
    this.promotion = this.querySelector(".promotion");
    this.handleBreakpoint = this.handleBreakpoint.bind(this);
    this.init = this.init.bind(this);
    this.destroy = this.destroy.bind(this);
  }
  connectedCallback() {
    this.handleBreakpoint();
    this.mq.addEventListener("change", this.handleBreakpoint);
  }
  disconnectedCallback() {
    this.mq.removeEventListener("change", this.handleBreakpoint);
  }
  handleBreakpoint() {
    if (this.mq.matches) {
      this.init();
    } else {
      this.destroy();
    }
  }
  init() {
    if (!this.promotion || this.dataset.initialized) return;
    this.dataset.initialized = "true";
    this.promotion.classList.add("promotion--animated");
    const containerWidth = this.offsetWidth;
    const itemWidth = this.promotion.offsetWidth;
    if (!itemWidth) return;
    const cloneCount = Math.ceil(containerWidth / itemWidth) + 2;
    for (let i = 0; i < cloneCount; i++) {
      const clone = this.promotion.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.classList.add("is-clone");
      const imageWrapper = clone.querySelector(".media-wrapper");
      if (imageWrapper) imageWrapper.classList.remove("loading");
      this.appendChild(clone);
    }
    const duration =
      (this.promotion.clientWidth / this.config.space) * this.config.moveTime;
    this.style.setProperty("--duration", `${duration}s`);
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.classList.toggle(
            "scrolling-promotion--paused",
            !entry.isIntersecting,
          );
        });
      },
      { rootMargin: "0px 0px 50px 0px" },
    );

    this.observer.observe(this);
  }

  destroy() {
    if (!this.dataset.initialized) return;

    this.dataset.initialized = "";

    this.promotion.classList.remove("promotion--animated");

    // Remove clones
    this.querySelectorAll(".is-clone").forEach((el) => el.remove());

    // Remove duration
    this.style.removeProperty("--duration");

    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define("scrolling-promotion", ScrollingPromotion);